<template>
  <div class="side-setting-switch">
    <el-switch
      size="small"
      v-model="sideSetting"
      active-text="위젯설정"
      inactive-text="위젯모음"
      :active-value="DashboardConst.SIDE_SETTING_TYPE.SETTING"
      :inactive-value="DashboardConst.SIDE_SETTING_TYPE.ELEMENT"
      active-color="#409EFF"
      inactive-color="#409EFF">
    </el-switch>
  </div>
</template>

<script>
import { filter, isEmpty } from 'lodash';

import Base from '@/mixins/dashboard/base';

import DashboardConst from '@/constants/dashboard';

export default {
  name: 'WSideSettingSwitch',
  mixins: [Base],
  data() {
    return {
      DashboardConst,
    };
  },
  computed: {
    activeWidgets() {
      const activeWidgets = filter(this.widgetLayout, ['active', true]);

      return !isEmpty(activeWidgets);
    },
    sideSetting: {
      get() {
        return this.sideSettingType;
      },
      set(value) {
        this.$store.commit('setSideSettingType', value);
      },
    },
  },
  watch: {
    activeWidgets(isActive) {
      // 선택 된 위젯 여부에 따라 좌측 영역 탭을 변경
      this.$store.commit('setSideSettingType', isActive ? DashboardConst.SIDE_SETTING_TYPE.SETTING : DashboardConst.SIDE_SETTING_TYPE.ELEMENT);
    },
  },
  beforeDestroy() {
  },
  methods: {},
};
</script>

<style lang="scss">
.side-setting-switch {
  .el-switch__label {
    color: #ccc;

    &.is-active {
      color: #333;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/views/dashboard/components/SideSettingSwitch.vue